import React, { Component } from 'react';

import { 
    Row,
    Col,
    Form,
    Modal,
    Button,
    CloseButton,
} from "react-bootstrap-v5";

import Utils from '../../../utils/utils'

import { connect } from 'react-redux'
import { clear } from "../../../../setup/redux/actions";
import { dispatchApiCallGet, dispatchApiCallPost, dispatchApiCallPut } from '../../../../setup/redux/dispatch/actions'


class CancelDialog extends Component {
  
    constructor(props){
        super(props);

        this.pageName = 'job_cancell_dialog';

        this.state = {
            driverNoteText: '',
            driverNoteTextValidated: false,
        }
    }


    header = () => {
        return <Modal.Header>
            <Row className={'align-items-center gx-0 w-100'}>
                <Col xs={true}>
                    <Modal.Title>Cancel job</Modal.Title>
                </Col>
                <Col xs={'auto'}>
                    <CloseButton
                        className={'rounded-2'}
                        onClick={() => {
                            if(this.props.onHide){
                                this.props.onHide();
                            }
                        }}
                    />
                </Col>
            </Row>
        </Modal.Header>
    }
    
    body = () => {
        return <Modal.Body>
            <Row>
                <Col xs={12}>
                    {this.fields()}
                </Col>
            </Row>
        </Modal.Body>
    }

    footer = () => {
        return <Modal.Footer>
            <Row className={'w-100'}>
                <Col xs={true}>
                    
                </Col>
                <Col xs={'auto'}>
                   <Button 
                        type={'button'}
                        variant={'light'}
                        disabled={this.state.isLoading}
                        onClick={() => {
                          if(this.props.onHide) {
                            this.props.onHide()
                          }
                        }}
                    >
                      No
                    </Button>
                </Col>
                <Col xs={'auto'}>
                   <Button 
                        type={'button'}
                        variant={'danger'}
                        disabled={this.state.isLoading || (this.state.driverNoteText == '')}
                        onClick={() => {
                          if(this.props.onOk) {
                            this.props.onOk({
                              driverNoteText: this.state.driverNoteText,
                            })
                          }
                        }}
                    >
                      Yes
                    </Button>
                </Col>
            </Row>
        </Modal.Footer>
    }


    fields = () => {
      return <Row>
        <Col xs={12}>
          <Form.Group className={'mb-5'}>
              <Form.Label>Cancellation Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                id={this.pageName + 'Cancellation_Remarks_driverNoteText'}
                placeholder={Utils.placeholderRows(5)}
                disabled={this.state.isLoading}
                value={this.state.driverNoteText}
                onChange={(e) => {
                  Utils.limitRows(e.target.value, 5, async (value) => {
                    this.setState({
                      driverNoteText: e.target.value,
                      driverNoteTextValidated: ((e.target.value !== '') ? false : true),
                    });
                  });
                }}
                isInvalid={this.state.driverNoteText == ''}
              />
              <Form.Control.Feedback type="invalid">You must fill in the field</Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    }


    render() {
        return <>
            {this.header()}
            {this.body()}
            {this.footer()}
        </>
    }
}

const mapDispatchToProps = {
  dispatchApiCallGet,
  dispatchApiCallPost,
  dispatchApiCallPut,
  clear,
}

export default connect(Utils.mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(CancelDialog);
